import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithGoogle, sendMagicLink } from '../../firebase/firebaseAuth';
import './AuthModal.css';

function AuthModal({ mode, onClose, onSwitchMode }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    setError('');
    setIsLoading(true);
    
    try {
      const result = await signInWithGoogle();
      if (result.success) {
        navigate('/chat/INTP');
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailLink = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);
    
    if (!email) {
      setError('Please enter your email address');
      setIsLoading(false);
      return;
    }
    
    try {
      const result = await sendMagicLink(email);
      if (result.success) {
        setMessage(result.message || `Magic link sent to ${email}. Please check your inbox.`);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        
        <h2>{mode === 'signup' ? 'Create your account' : 'Welcome back'}</h2>
        <p className="auth-subtitle">Connect with your MBTI persona</p>
        
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        
        <button className="social-button google-button" onClick={handleGoogleSignIn} disabled={isLoading}>
          <img src="/images/googleIcon.png" alt="Google" className="google-icon" />
          Continue with Google
        </button>
        
        <div className="divider">
          <span>OR</span>
        </div>
        
        {/* Email Link Form (same for both login and signup) */}
        <form onSubmit={handleEmailLink}>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoading}
            placeholder="Enter your email address"
            className="email-input"
          />
          
          <button type="submit" className="submit-button" disabled={isLoading}>
            {isLoading ? 'Sending link...' : 'Continue with Email'}
          </button>
        </form>
        
        <div className="switch-mode">
          {mode === 'signup' ? (
            <p>Already have an account? <button onClick={() => onSwitchMode('login')} disabled={isLoading}>Log In</button></p>
          ) : (
            <p>Don't have an account? <button onClick={() => onSwitchMode('signup')} disabled={isLoading}>Sign Up</button></p>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthModal;
